import React, { useContext, useEffect, useState } from 'react'
import { Tabs, TabPanel, TabList, Tab } from "react-tabs";
import { Navigation, Pagination, EffectFade, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { AnimatePresence, motion } from "framer-motion";
import { useRouter } from 'next/router';
import ServicesCard from './ServicesCard';
import { isMobileContext } from '../../contexts/isMobileContext';
import FadeIn from '../Animations/FadeIn';
import Magnitizer from '../Animations/Magnitizer';
const Services = ({ servicesData, servicesHeader }) => {
    const { locale } = useRouter()
    const { isMobile } = useContext(isMobileContext);
    const [slideNumber0, setSlideNumber0] = useState('0' + 1)
    const [slideNumber1, setSlideNumber1] = useState('0' + 1)
 

    return (
        <div className='services-section'>
            <Tabs>
                <FadeIn customClass='header'>
                    <h2 className='title light _eleX'>{servicesHeader}</h2>
                </FadeIn>
                <div className="tabs-panels">
                    {servicesData?.map((tab, index) => (
                        <div key={index + "tabs"}>
                            <FadeIn customClass='tab-data'>
                                <div className='tab-header _eleX light'>
                                    <span>{tab?.Headline}</span>
                                </div>
                            </FadeIn>
                            <FadeIn customClass='swiper-container'>
                                <Swiper
                                    key={tab?.Our_Finishes?.length}
                                    style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                                    modules={[
                                        Navigation,
                                        Pagination,
                                        EffectFade,
                                    ]}

                                    navigation={{
                                        nextEl: index == 0 ? `.swiper-button-next-serv-first` : `.swiper-button-next-serv-second`,
                                        prevEl: index == 0 ? `.swiper-button-prev-serv-first` : `.swiper-button-prev-serv-second`,
                                    }}
                                    pagination={{
                                        type: "progressbar",
                                        el: `.swiper-services-navigation${index}`,
                                    }}
                                    className="swiper-serv-section"
                                    slidesPerView={1}
                                    spaceBetween={25}
                                    onSlideChange={(swiper) => { 
                                        index==0?
                                        setSlideNumber0('0' + (swiper.realIndex + 1)) :
                                        setSlideNumber1('0' + (swiper.realIndex + 1)) 
                                    }}
                                    breakpoints={{
                                        768: {
                                            slidesPerView: 2.5,
                                            spaceBetween: 20,
                                        },
                                        1024: {
                                            slidesPerView: 4,
                                            spaceBetween: 50,
                                        },
                                    }}
                                >
                                    {tab?.Our_Finishes?.map((data, index) => (
                                        <SwiperSlide key={index}>
                                            <ServicesCard cardData={data} index={index} />
                                        </SwiperSlide>
                                    ))}

                                </Swiper>
                            </FadeIn>
                            <div
                                className={`swiper-navigation-continer
                                    ${isMobile && tab?.Our_Finishes?.length < 2 && "d-none"}
                                    ${!isMobile && tab?.Our_Finishes?.length < 5 && "d-none"}`}
                            >
                                <div className="navigation-container">
                                    <div className="slide-number-container bold">
                                        <div>{index==0?slideNumber0:slideNumber1}</div>
                                        <div>{isMobile ? "0" + tab?.Our_Finishes?.length : "0" + Math.ceil(tab?.Our_Finishes?.length / 4)}</div>
                                    </div>
                                    <div className={`swiper-services-navigation${index} swiper-pagination-progressbar`}></div>
                                </div>
                                <div className="arrows-container">
                                    <Magnitizer dataDest={1.5}>
                                        <div className={`swiper-button-prev
                                        ${index == 0 ? 'swiper-button-prev-serv-first' : 'swiper-button-prev-serv-second'}
                                         serv-arrow black-arrow-prev`}
                                        ></div>
                                    </Magnitizer>
                                    <Magnitizer dataDest={1.5}>
                                        <div className={`swiper-button-next 
                                        ${index == 0 ? 'swiper-button-next-serv-first' : 'swiper-button-next-serv-second'}
                                        serv-arrow black-arrow-next`}
                                        ></div>
                                    </Magnitizer>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Tabs>
        </div>
    )
}

export default Services
